module.exports = __webpack_public_path__ + "img/IMG_20200821_172526.150c7687.150c7687.jpg";